import { render, staticRenderFns } from "./005mojingone.vue?vue&type=template&id=8790166c&scoped=true&"
import script from "./005mojingone.vue?vue&type=script&lang=js&"
export * from "./005mojingone.vue?vue&type=script&lang=js&"
import style0 from "./005mojingone.vue?vue&type=style&index=0&id=8790166c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8790166c",
  null
  
)

export default component.exports